import type { FontPreset, LabelType } from "../../api/types";

export const FONT_PRESETS: { value: FontPreset; labelKey: string; supportsBold: boolean }[] = [
  { value: "scalable",      labelKey: "labelEditor.fonts.scalable",      supportsBold: true },
  { value: "bitmap_small",  labelKey: "labelEditor.fonts.bitmap_small",  supportsBold: false },
  { value: "bitmap_medium", labelKey: "labelEditor.fonts.bitmap_medium", supportsBold: false },
  { value: "bitmap_large",  labelKey: "labelEditor.fonts.bitmap_large",  supportsBold: false },
  { value: "monospace",     labelKey: "labelEditor.fonts.monospace",     supportsBold: true },
];

export const FONT_CSS: Record<FontPreset, { family: string; weight?: number }> = {
  scalable:      { family: "system-ui, Arial, sans-serif" },
  bitmap_small:  { family: "system-ui, Arial, sans-serif" },
  bitmap_medium: { family: "system-ui, Arial, sans-serif" },
  bitmap_large:  { family: "system-ui, Arial, sans-serif" },
  monospace:     { family: "'Courier New', ui-monospace, monospace" },
};

// Câmpuri derivate din livrare, utile pe orice etichetă legată de o livrare.
const SHIPMENT_EXTRA = ["customer", "branch", "location", "date", "qty"];

export const ALLOWED_FIELDS: Record<LabelType, string[]> = {
  device:         ["model", "dev_eui", "lot", ...SHIPMENT_EXTRA],
  box:            ["range", "dev_euis", "shipment_code", ...SHIPMENT_EXTRA],
  partida_small:  ["shipment_code", "label_text", "timestamp", "url", ...SHIPMENT_EXTRA],
  partida_large:  ["shipment_code", "label_text", "timestamp", "url", ...SHIPMENT_EXTRA],
  link_small:     ["shipment_code", "label_text", "timestamp", "public_url", ...SHIPMENT_EXTRA],
  link_large:     ["shipment_code", "label_text", "timestamp", "public_url", ...SHIPMENT_EXTRA],
  passport_small: ["passport_url", "model", "dev_eui", "label_text", "timestamp", ...SHIPMENT_EXTRA],
  passport_large: ["passport_url", "model", "dev_eui", "label_text", "timestamp", ...SHIPMENT_EXTRA],
  stock_item:     ["stock_code", "name", "label_text", "timestamp"],
};

export const FIELD_PREVIEW: Record<string, string> = {
  model: "3010.50000270.2512",
  dev_eui: "aabbccddeeff0011",
  lot: "LOT: SH24",
  range: "1-50",
  dev_euis: "[…all DEV_EUIs as QR]",
  shipment_code: "GM-LW-007",
  label_text: "PARTIDA",
  timestamp: "2026-05-21 18:24",
  url: "https://server.fst.md/sh/GM-LW-007",
  public_url: "https://server.fst.md:2443/dl/MW6MV2M5APNJQ",
  passport_url: "https://server.fst.md:2443/p/847447a8c9135b94",
  customer: "SRL EXEMPLU",
  branch: "ORHEI GAZ",
  location: "Orhei",
  date: "21.05.2026",
  qty: "50",
  stock_code: "STK:16",
  name: "Power Supply 24v",
};

export const ROTATIONS: { value: 0 | 90 | 180 | 270; label: string }[] = [
  { value: 0,   label: "0°" },
  { value: 90,  label: "90°" },
  { value: 180, label: "180°" },
  { value: 270, label: "270°" },
];

export const DOTS_PER_MM = 8;  // 203 dpi
